'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/table/style/css');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderFinance = _react2.default.createClass({
    displayName: 'OrderFinance',
    render: function render() {
        var columns = [{
            title: '交易时间',
            key: '0',
            dataIndex: 'created_at'
        }, {
            title: '流水号',
            key: '1',
            dataIndex: 'transaction_no'
        }, {
            title: '交易金额',
            key: '2',
            dataIndex: 'fee'
        }, {
            title: '支付方式',
            key: '3',
            dataIndex: 'channel_info'
        }, {
            title: '备注',
            key: '4',
            dataIndex: 'memo'
        }];

        var tableConfig = {
            columns: columns,
            dataSource: this.props.finances,
            pagination: false,
            bordered: true,
            rowKey: function rowKey(record) {
                return record.id;
            }
        };
        return _react2.default.createElement(_table2.default, tableConfig);
    }
}); /**
     * 订单财务记录信息
     */

exports.default = OrderFinance;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/order_finance.js
// module id = 1192
// module chunks = 0